// extracted by mini-css-extract-plugin
export default {"BoxBanner":"InfoBanner_BoxBanner__Zpzc8","Banner":"InfoBanner_Banner__fC1JU","Action":"InfoBanner_Action__F7Zkr"};